import fineTuneTypeaheadView from './fineTuneTypeaheadComponent.html';
import './fineTuneTypeaheadComponent.css';
import { ensure } from 'components/sharpr/ensure/ensure';

export function fineTuneTypeaheadComponent() {
	return {
		bindings: {
			search: '=',
		},
		controllerAs: 'vm',
		controller: fineTuneTypeaheadComponentCtrl,
		template: fineTuneTypeaheadView,
	};
}

export class fineTuneTypeaheadComponentCtrl {
	constructor(Api, Taxonomy) {
		'ngInject';
		this.typeaheadItems = [];
		this.term = '';
		Taxonomy.getCategories().then(this._processCategories.bind(this));
		Taxonomy.getTags().then(this._processTags.bind(this));
		Taxonomy.getUsers().then(this._processUsers.bind(this));
	}

	onChoose(item) {
		let [$0, type, value] = item.id.match(/(\w+):(.+)/);
		if (type == 'category') {
			this.search.categories = [+value];
		} else if (type == 'tag') {
			this.search.tags = [value];
		} else if (type == 'user') {
			this.search.publishers = [+value];
		}
		this.model = '';
		this.term = '';
	}

	searchTerm() {
		this.search.term = this.term;
		this.model = '';
	}

	_processCategories(categories) {
		ensure.array(categories).forEach(cat => {
			if (!cat.is_active || cat.name == '-----') {
				return;
			}
			this.typeaheadItems.push({
				id: 'category:' + cat.id,
				icon: 'folder',
				$search: cat.name,
			});
		});
	}

	_processTags(tags) {
		ensure.array(tags).forEach(tag => {
			this.typeaheadItems.push({
				id: 'tag:' + tag.name,
				icon: 'tag',
				$search: tag.name,
			});
		});
	}

	_processUsers(users) {
		ensure.array(users).forEach(user => {
			this.typeaheadItems.push({
				id: 'user:' + user.id,
				icon: 'user',
				$search: `${user.fname_preferred || user.fname} ${user.lname_preferred || user.lname} <${user.email}>`,
			});
		});
	}
}
